(function () {
  personalisation();

  function personalisation() {
    // Quick view injects a second copy of this snippet into the DOM (on top of
    // the one already on the product page, e.g. via a complementary-products
    // quick-add card) and re-runs this script, so support multiple independent
    // instances instead of assuming a single global `.customization-product`.
    document.querySelectorAll('.customization-product').forEach(initPersonalisationInstance);
  }

  function initPersonalisationInstance(customizationProduct) {
    if (customizationProduct.dataset.personalisationInitialized === 'true') return;
    customizationProduct.dataset.personalisationInitialized = 'true';

    // The snippet can render anywhere on the page relative to the buy buttons
    // (e.g. right after the variant picker), so look up the associated <form>
    // by id rather than relying on DOM proximity to <product-form>.
    const productFormId = customizationProduct.dataset.productFormId;
    const productFormEl = productFormId ? document.getElementById(productFormId) : null;
    const submitButton = productFormEl?.querySelector('.product-form__submit[type="submit"]');
    const dynamicCheckoutWrapper = productFormEl?.querySelector('.product-form__dynamic-checkout-wrapper');

    // Remember when the button is disabled for reasons outside our control (sold
    // out / unavailable variant) so our gating never re-enables it. This is
    // re-synced on every variant change below, since stock availability changes
    // per variant, not just once at page load.
    let stockDisabled = submitButton?.disabled ?? false;

    const groups = Array.from(customizationProduct.querySelectorAll('[data-personalisation-group]'));

    function applyGateState() {
      const blocked = groups.some((group) => {
        const yesInput = group.querySelector('.customization-toggle__input[value="yes"]');
        if (!yesInput?.checked) return false;
        const input = group.querySelector('[data-personalisation-input]');
        return !input || input.value.trim() === '';
      });

      if (submitButton) {
        submitButton.disabled = blocked || stockDisabled;
      }
      if (dynamicCheckoutWrapper) {
        dynamicCheckoutWrapper.classList.toggle('product-form__dynamic-checkout-wrapper--blocked', blocked);
      }
    }

    function setGroupState(group, isYes) {
      const field = group.querySelector('[data-personalisation-field]');
      const input = group.querySelector('[data-personalisation-input]');
      const noCustomInput = group.querySelector('.noCustom');
      const errorLabel = group.querySelector('[data-personalisation-error]');
      const toggle = group.querySelector('.customization-toggle');

      toggle?.classList.toggle('customization-toggle--yes', isYes);
      if (errorLabel) errorLabel.style.display = 'none';
      if (input) input.classList.remove('customization-input__field--invalid');

      if (isYes) {
        if (field) field.style.display = 'block';
        input?.removeAttribute('disabled');
        if (noCustomInput) {
          noCustomInput.setAttribute('disabled', 'disabled');
          noCustomInput.value = '';
        }
      } else {
        if (field) field.style.display = 'none';
        input?.setAttribute('disabled', 'disabled');
        if (noCustomInput) {
          noCustomInput.removeAttribute('disabled');
          noCustomInput.value = 'Customer requires no text';
        }
      }
    }

    function updateCounter(group) {
      const input = group.querySelector('[data-personalisation-input]');
      const counterCurrent = group.querySelector('[data-personalisation-counter-current]');
      if (input && counterCurrent) {
        counterCurrent.textContent = input.value.length;
      }
    }

    function validateInput(group) {
      const input = group.querySelector('[data-personalisation-input]');
      const errorLabel = group.querySelector('[data-personalisation-error]');
      if (!input) return;

      const isEmpty = input.value.trim() === '';
      if (errorLabel) errorLabel.style.display = isEmpty ? 'block' : 'none';
      input.classList.toggle('customization-input__field--invalid', isEmpty);
    }

    groups.forEach((group) => {
      const radios = group.querySelectorAll('.customization-toggle__input');
      const input = group.querySelector('[data-personalisation-input]');

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const isYes = radio.value === 'yes';
          setGroupState(group, isYes);
          applyGateState();
          // Only autofocus on an actual user click, not the initial state
          // sync below (which also calls setGroupState with isYes: true when
          // a group happens to load already-checked "yes") — and only when
          // there's nothing typed yet, so toggling No then back to Yes
          // doesn't steal focus away from text the user already entered.
          if (isYes && input?.value.trim() === '') input.focus();
        });
      });

      input?.addEventListener('input', () => {
        updateCounter(group);
        validateInput(group);
        applyGateState();
      });

      const checkedRadio = group.querySelector('.customization-toggle__input:checked');
      setGroupState(group, checkedRadio?.value === 'yes');
      updateCounter(group);
    });

    applyGateState();

    // Changing variant re-fetches the section and resets the submit button's
    // disabled state to the new variant's stock availability (theme code runs
    // this, and publishes this event, synchronously before our handler here).
    // Capture that fresh value as the new stock baseline, then re-apply our own
    // gating on top of it.
    //
    // Quick view can tear this instance's DOM down (modal close clears its
    // content) without ever telling us, and this subscription would otherwise
    // live for the rest of the page's lifetime holding a reference to the
    // detached nodes. Self-unsubscribe the first time we notice we're no
    // longer in the document.
    const unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, () => {
      if (!customizationProduct.isConnected) {
        unsubscribeVariantChange();
        return;
      }
      stockDisabled = submitButton?.disabled ?? false;
      applyGateState();
    });
  }
})();
